/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@atlaskit/css';

import type { IssueTypeField } from '../../../api/useIssueSearchQuery/types';

export const IssueTypeNode = ({ IssueTypeField }: { IssueTypeField: IssueTypeField }) => {
	return (
		<img
			height="16"
			width="16"
			src={IssueTypeField.issueType.avatar.small}
			alt={IssueTypeField.issueType.name}
		/>
	);
};
